import httpClient from 'utils/httpClient';
import { CHAT_BACKEND_URL } from 'configs/env.conf';

export interface IBanner {
  id: string;
  titleI18n?: any;
  messageI18n?: any;
  titleLegacy: string;
  messageLegacy: string;
  type: string;
  actionType: 'link' | 'modal' | 'none';
  actionUrl?: string;
  actionLabelI18n?: any;
  actionLabelLegacy?: string;
  icon?: string;
  backgroundColor?: string;
  textColor?: string;
  imageUrl?: string;
  startAt: string;
  endAt: string;
  priority: number;
  isDismissible: number; // 1 or 0
  isPersistent: number; // 1 or 0
  targetAudience?: string;
  metadata?: {
    ratio?: string;
    displayMode?: string;
  };
}

export interface GetBannersResponse {
  data: {
    data: IBanner[];
    total: number;
    page: number;
    limit: number;
  };
  _status: number;
  _messages: any[];
}

export const getActiveBanners = async (
  targetAudience: string = 'teachers',
): Promise<IBanner[]> => {
  const BACKEND_URL = CHAT_BACKEND_URL;
  try {
    const response = await httpClient.get<GetBannersResponse>(
      `${BACKEND_URL}/announcement-banners`,
      {
        params: {
          target: targetAudience,
          isActive: 1,
        },
      },
    );
    return response?.data?.data?.data || [];
  } catch (error) {
    console.error('Failed to fetch banners:', error);
    return [];
  }
};
